import React, { FC, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useStatistics } from '../../lib/statistics';
import { UserPage } from '../../components/UserPage';
import { Section } from '../../components/Section';


type SpotList = {
    id: number;
    name: string;
}[];


export const SpotListPage: FC = (props) => {
    // @ts-ignore
    const genre = props.match.params.genre;
    const [spotList, setSpotList] = useState<SpotList>();
    const { getSpotList } = useStatistics();

    useEffect(() => {
        async function initialize() {
            const resp = await getSpotList(genre);
            setSpotList(resp);
        };
        initialize();
    }, []);

    return (
        <UserPage previous="/map/list" title={`Salon.jp | ${genre}の一覧`}>
            <Section>
                <div className="title">
                    <h1>{genre}の一覧</h1>
                </div>
                {spotList ? <ul className="shops">
                    {spotList.map(({ id, name }) => (
                        <li>
                            <a className="spot-link" href={`/stores/${id}/`}>
                                {name}
                            </a>
                        </li>
                    ))}
                </ul> : null}
            </Section>

            <style jsx>{`
                .title {
                    padding-top: 50px;
                    padding-bottom: 26px;
                }
                h1 {
                    font-weight: normal;
                    font-size: 20px;
                    margin: 0;
                }
                .total-count {
                    margin-top: 0;
                    font-size: 12px;
                }
                .shops {
                    margin: 0;
                    padding: 0;
                }
                ul {
                    list-style-type: none;
                }
                li {
                    margin-bottom: 20px;
                }
                :global(.spot-link) {
                    color: #fe8125;
                    font-size: 16px;
                    text-decoration: none;
                }
                @media screen and (max-width: 540px) {
                    .title {
                        padding-top: 24px;
                        padding-bottom: 24px;
                    }
                    :global(.spot-link) {
                        font-size: 12px;
                    }
                }
            `}</style>
        </UserPage>
    );
};
